/* ms-precio-sesion.js — precio por sesión dentro del selector de Seal.
   Escribe "X,XX € por sesión" en el hueco .sls-price-below que Seal deja
   vacío bajo el precio de cada opción.
   El importe se calcula dividiendo el precio que Seal muestra entre las
   sesiones de la caja, así que si cambia el precio o el descuento no hay
   que tocar nada aquí.
   No cubre el 20% de la sexta entrega: eso es retención y va por correo.

   Dos cosas que costaron sangre:
   1. Seal rehace su widget entero varias veces (al montar, al cambiar de
      variante y al cambiar el intervalo) y sustituye el nodo contenedor,
      así que el observador va sobre el documento y no sobre el
      contenedor: enganchado al contenedor, el nodo se queda huérfano y
      deja de avisar.
   2. Nada de requestAnimationFrame: en una pestaña en segundo plano no
      se ejecuta, y el repintado se queda colgado. setTimeout sí corre.
   Estilos en línea a propósito, para no depender de otro archivo.
   2026-09-02 */
(function () {
  'use strict';

  if (window.msPrecioSesion) return;
  window.msPrecioSesion = true;

  var SESIONES = 21;

  function aNumero(txt) {
    if (!txt) return NaN;
    var limpio = txt.replace(/[^0-9,.]/g, '').trim();
    /* formato español: el punto separa miles, la coma decimales */
    limpio = limpio.split('.').join('').replace(',', '.');
    return parseFloat(limpio);
  }

  function formatear(n) {
    return n.toLocaleString('es-ES', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + ' € por sesión';
  }

  function pintar() {
    var opciones = document.querySelectorAll(
      '.sls-purchase-options-container .sls-option-container'
    );
    var pintadas = 0;

    for (var i = 0; i < opciones.length; i++) {
      var op = opciones[i];
      var hueco = op.querySelector('.sls-price-below');
      /* .sls-price-below cuelga DENTRO de .sls-price, así que el importe
         hay que leerlo del span.money o se acabaría leyendo lo que este
         script acaba de escribir. */
      var precio = op.querySelector('.sls-price .money') ||
                   op.querySelector('.sls-price');
      if (!hueco || !precio) continue;

      var valor = aNumero(precio.textContent);
      if (!isFinite(valor) || valor <= 0) continue;

      var texto = formatear(valor / SESIONES);
      var nodo = hueco.querySelector('[data-ms-sesion]');

      if (!nodo) {
        nodo = document.createElement('span');
        nodo.setAttribute('data-ms-sesion', '1');
        nodo.style.display = 'block';
        nodo.style.fontSize = '13px';
        nodo.style.lineHeight = '13px';
        nodo.style.fontWeight = '400';
        nodo.style.color = '#6B6B6B';
        nodo.style.marginTop = '4px';
        nodo.style.whiteSpace = 'nowrap';
        hueco.appendChild(nodo);
      }
      if (nodo.textContent !== texto) nodo.textContent = texto;
      pintadas++;
    }
    return pintadas;
  }

  var pendiente = null;
  function pintarDiferido() {
    if (pendiente) return;
    pendiente = setTimeout(function () {
      pendiente = null;
      pintar();
    }, 16);
  }

  function interesa(muts) {
    for (var i = 0; i < muts.length; i++) {
      var t = muts[i].target;
      if (t && t.nodeType !== 1) t = t.parentElement;
      if (!t || !t.closest) return true;
      /* lo que escribe este mismo script no cuenta */
      if (t.closest('[data-ms-sesion]')) continue;
      return true;
    }
    return false;
  }

  new MutationObserver(function (muts) {
    if (interesa(muts)) pintarDiferido();
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });

  pintar();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pintar);
  }
  /* red de seguridad: se repasa un rato aunque el observador falle */
  var intentos = 0;
  var reloj = setInterval(function () {
    intentos++;
    pintar();
    if (intentos > 60) clearInterval(reloj);
  }, 400);
  document.addEventListener('shopify:section:load', pintar);
  document.addEventListener('visibilitychange', pintar);
})();